import React from 'react';
import { Base } from 'lib/cortiUI';
import { Discard } from './Discard';
import { Publish } from './Publish';
export const Actions = ({ disabled = false, templateID }) => {
    return (React.createElement(Base, { display: "flex", gap: 6 },
        React.createElement(Discard, { templateID: templateID, disabled: disabled }),
        React.createElement(Publish, { templateID: templateID, disabled: disabled })));
};
